import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { toggleSidebar } from '../../store/actions/layout';

const Question = () => {
   const dispatch = useDispatch();
   const { isAuthenticated } = useSelector((state) => state.auth);
   const { isSidebarOpened } = useSelector((state) => state.layout);

   useEffect(() => {
      window.scrollTo(0, 0);
   }, []);
   useEffect(() => {
      const body = document.querySelector('body');
      const questionScript = document.createElement('script');
      questionScript.src = './js/question.js';
      questionScript.async = true;
      body.appendChild(questionScript);
      return () => {
         body.removeChild(questionScript);
      };
   }, []);
   return (
      <main className='questions' onClick={() => isSidebarOpened && dispatch(toggleSidebar())}>
         <div className='questions__content'>
            <div id='one' className='kards__card kards__card-question'>
               <h1 className='questions__list-box'>سوالات متداول نمایندگی ها</h1>
               <div className='questions__list-section'>
                  <h2 className='dropdown'>ساعت کاری نمایندگی ها چه زمانی است؟</h2>
                  <p className='questions__list-text'>- از 8 صبح تا 21 شب</p>
               </div>
               <div className='questions__list-section'>
                  <h2 className='dropdown'>ساعت تحویل کالا چه زمانی است؟</h2>
                  <p className='questions__list-text'>- از 9 صبح تا 16</p>
               </div>
               <div className='questions__list-section'>
                  <h2 className='dropdown'>ساعت دریافت کالا چه زمانی است؟</h2>
                  <p className='questions__list-text'>- از 8 تا 21 شب</p>
               </div>
               <div className='questions__list-section'>
                  <h2 className='dropdown'>نحوه ی ارسال بار چگونه است؟</h2>
                  <p className='questions__list-text'>
                     - ارسال از طریق پست ملی ایران ،ارسال از طریق ناوگان اتوبوس رانی ، ارسال از طریق
                     پست لجستیک
                  </p>
               </div>
               <div className='questions__list-section'>
                  <h2 className='dropdown'>ممنوعیت ارسال بار چیست؟</h2>
                  <p className='questions__list-text'>
                     - کالاهای قاچاق ، مواد فاسد شدنی ، داروهای خاص ،حیوانات زنده
                  </p>
               </div>
               <div className='questions__list-section'>
                  <h2 className='dropdown'>امکان بسته بندی وجود دارد؟</h2>
                  <p className='questions__list-text'>
                     - درصورت نیاز به بسته بندی نمایندگی موقعیت شما خدمات بسته بندی را نیز ارایه
                     میدهد
                  </p>
               </div>
            </div>

            <div id='two' className='kards__card kards__card-question'>
               <h1 className='questions__list-box'>سوالات متداول ارسال</h1>

               <div className='questions__list-section'>
                  <h2 className='dropdown'>آیا برای ارسال بسته داشتن کد پستی گیرنده الزامیست؟</h2>
                  <p className='questions__list-text'>
                     - درصورت کامل بودن آردس گیرنده الزامی برای کد پستی وجود ندارد . بدیهی است در
                     صورت وجود کد پستی ارسال بسته دقیق تر انجام میگیرد
                  </p>
               </div>
               <div className='questions__list-section'>
                  <h2 className='dropdown'>
                     چگونه میتوان هزینه های پستی را قبل از ارسال بسته محاسبه نمود؟
                  </h2>
                  <p className='questions__list-text'>
                     - شما می توانید با مراجعه به وب سایت کالا پست و اپلیکیشن در قسمت برآورد قیمت
                     قبل از ارسال بسته ، از هزینه تقریبی مطلع شوید
                  </p>
               </div>
               <div className='questions__list-section'>
                  <h2 className='dropdown'>ممنوعیت ارسال بار چیست؟</h2>
                  <p className='questions__list-text'>
                     - کالاهای قاچاق ، مواد فاسد شدنی ، داروهای خاص ، حیوانات زنده
                  </p>
               </div>
               <div className='questions__list-section'>
                  <h2 className='dropdown'>نحوه ی رهگیری مرسوله چگونه است؟</h2>
                  <p className='questions__list-text'>
                     - شما می توانید با مراجعه به وب سایت کالاپست ، اپلیکیشن و سامانه تلفنی کالا پست
                     03134358310 الی 14 از وضعیت بسته خود مطلع شوید
                  </p>
               </div>
               <div className='questions__list-section'>
                  <h2 className='dropdown'>انواع ارسال چیست؟</h2>
                  <p className='questions__list-text'>
                     - ارسال از طریق ناوگان اتوبوسی ، ارسال از طریق پست ملی ایران ، ارسال کالاپستی
                  </p>
               </div>
               <div className='questions__list-section'>
                  <h2 className='dropdown'>فرآیند ارسال مرسولات شکستنی چگونه است؟</h2>
                  <p className='questions__list-text'>
                     - ارسال مرسولات شکستنی در صورتی که بسته بندی مناسب و مورد تایید کالاپست داشته
                     باشند، بلامانع است و ارسال میشود
                  </p>
               </div>
               <div className='questions__list-section'>
                  <h2 className='dropdown'>فرایند تغییر آدرس گیرنده چگونه است؟</h2>
                  <p className='questions__list-text'>
                     - برای تغییر آدرس گیرنده ، فرستنده باید درخواست خود مبنی بر تغییر آدرس را به
                     شعبه مبدا اعلام کند. پس از آن هماهنگی لازم برای تغییر آدرس صورت می گیرد
                  </p>
               </div>
            </div>

            <div id='three' className='kards__card kards__card-question'>
               <h1 className='questions__list-box'>سوالات متداول پیگیری و شکایات</h1>

               <div className='questions__list-section'>
                  <h2 className='dropdown'>
                     مشتریان چگونه میتوانند سوالات ، پیشنهادات و شکایات خود را با مسولین کالاپست در
                     میان بگذارند؟
                  </h2>
                  <p className='questions__list-text'>
                     - مشتریان میتوانند از طریق سامانه تلفنی 03134358310 الی 14 پاسخ سوالات مختلف
                     خود را دریافت نمایند ، همچنین میتوانند در صفحه ارتباط با مدیر عامل شکایات و
                     انتقادات خود را مستقیم به گوش مدیر عامل کالاپست برسانند
                  </p>
               </div>
               <div className='questions__list-section'>
                  <h2 className='dropdown'>علت برگشت مرسولات و عدم تحویل چیست؟</h2>
                  <p className='questions__list-text'>
                     - مرسولاتی که به دلایلی مانند نقص نشانی،نقل مکان یا عدم پاسخ گویی گیرینده یا
                     مخدوش شدن آدرس،امکان تحویلشان به گیرنده وجود ندارد،به فرستنده عودت داده میشود
                  </p>
               </div>
               <div className='questions__list-section'>
                  <h2 className='dropdown'>ممنوعیت ارسال بار چیست؟</h2>
                  <p className='questions__list-text'>
                     - کالاهای قاچاق ، مواد فاسد شدنی ، داروهای خاص ، حیوانات زنده
                  </p>
               </div>
               <div className='questions__list-section'>
                  <h2 className='dropdown'>نحوه ی رهگیری شکایت ثبت شده چگونه است؟</h2>
                  <p className='questions__list-text'>
                     - شما می توانید با استفاده از کد رهگیری در صفحه ثبت شکایات وب سایت و اپلیکیشن
                     از جواب کارشناس کالاپست مطلع شوید
                  </p>
               </div>
               <div className='questions__list-section'>
                  <h2 className='dropdown'>فرآیند پیگیری برای دریافت هزنیه اضافی چگونه است؟</h2>
                  <p className='questions__list-text'>
                     - در صورت دریافت هزینه اضافه،می توانید با تماس با شماره 03134358310 الی 14 مبلغ
                     درج شده در فاکتور، مبلغ اضافی دریافت شده و نحوه پرداخت (نقدی و یا غیر نقدی) را
                     اعلام کرده و ثبت شکایت کنید. پس از بررسی و در صورت صحیح بودن مدارک ارسال شده
                     (رسید پرداخت) مبلغ اضافه به حساب شما بازگردانده خواهد شد.
                  </p>
               </div>
               <div className='questions__list-section'>
                  <h2 className='dropdown'>فرآیند پیگیری عدم جمع آوری مرسوله چگونه است؟</h2>
                  <p className='questions__list-text'>
                     - در صورتی که فرستنده برای ارسال بسته با شعبه تماس گرفته و یا در یکی از
                     درگاه‌های آنلاین ثبت سفارش داشته اما مرسوله جمع‌آوری نشده باشد، می‌تواند با
                     شماره 03134358310 الی 14تماس بگیرد و موضوع را اطلاع دهد. مورد به واحد پیگیری
                     ارجاع و دراسرع وقت نسبت به جمع‌آوری اقدام می‌شود.
                  </p>
               </div>
            </div>
         </div>
         <Link to='/order' className='main__Send-package'>
            <img className='main__Send-package-img' src='./img/postfix.png' alt='' />
            <h4>ارسال بسته</h4>
         </Link>
      </main>
   );
};

export default Question;
